import * as Types from '../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetServerDateQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetServerDateQueryQuery = { __typename?: 'Query', server: Date };


export const GetServerDateQueryDocument = gql`
    query getServerDateQuery {
  server: serverTime
}
    `;

/**
 * __useGetServerDateQueryQuery__
 *
 * To run a query within a React component, call `useGetServerDateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerDateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerDateQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServerDateQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetServerDateQueryQuery, GetServerDateQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServerDateQueryQuery, GetServerDateQueryQueryVariables>(GetServerDateQueryDocument, options);
      }
export function useGetServerDateQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServerDateQueryQuery, GetServerDateQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServerDateQueryQuery, GetServerDateQueryQueryVariables>(GetServerDateQueryDocument, options);
        }
export function useGetServerDateQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServerDateQueryQuery, GetServerDateQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServerDateQueryQuery, GetServerDateQueryQueryVariables>(GetServerDateQueryDocument, options);
        }
export type GetServerDateQueryQueryHookResult = ReturnType<typeof useGetServerDateQueryQuery>;
export type GetServerDateQueryLazyQueryHookResult = ReturnType<typeof useGetServerDateQueryLazyQuery>;
export type GetServerDateQuerySuspenseQueryHookResult = ReturnType<typeof useGetServerDateQuerySuspenseQuery>;
export type GetServerDateQueryQueryResult = Apollo.QueryResult<GetServerDateQueryQuery, GetServerDateQueryQueryVariables>;